/** Estilos HUD compartilhados — dialogs e painéis do módulo Contratos */

export const HUD_GRADIENT =
  'linear-gradient(135deg, rgba(15,23,42,0.95) 0%, rgba(30,64,175,0.9) 55%, rgba(13,148,136,0.82) 100%)';

export const HUD_DIALOG_PAPER = {
  borderRadius: 3,
  overflow: 'hidden',
  boxShadow: '0 24px 64px rgba(15,23,42,0.28)',
};

export const HUD_DIALOG_TITLE = {
  background: HUD_GRADIENT,
  color: '#e2e8f0',
  py: 2,
};

export const HUD_DIALOG_CONTENT = {
  bgcolor: 'rgba(248,250,252,0.95)',
};

export const HUD_CTA_BUTTON = {
  textTransform: 'none',
  fontWeight: 800,
  background: 'linear-gradient(90deg, #1d4ed8, #0d9488)',
  boxShadow: '0 8px 20px rgba(29,78,216,0.25)',
};

export const HUD_CARD = {
  p: 2,
  borderRadius: 2.5,
  border: '1px solid rgba(15,23,42,0.08)',
  bgcolor: 'rgba(255,255,255,0.96)',
  boxShadow: '0 4px 14px rgba(15,23,42,0.04)',
  background: 'linear-gradient(165deg, rgba(255,255,255,0.98) 0%, rgba(240,253,250,0.55) 100%)',
};

export const HUD_STEP_NUMBER = {
  width: 36,
  height: 36,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 800,
  fontSize: '0.85rem',
  color: '#ccfbf1',
  background: 'linear-gradient(135deg, #1d4ed8, #0d9488)',
  boxShadow: '0 4px 12px rgba(13,148,136,0.35)',
  flexShrink: 0,
};
